import Icon from "app/components/shared/Icon";
import { State, Step } from "app/lib/pipeline";
import { StepLink } from "./StepLink";
import { resolveStepUrl } from "app/components/build/Show/lib/urlForView";
import useCurrentJobOrStep from "app/components/build/Show/lib/useCurrentJobOrStep";

interface Props {
  step: Step;
  depth?: number;
}

export function WaitStepListItem({ step, depth = 0 }: Props) {
  const { currentStep } = useCurrentJobOrStep();

  return (
    <StepLink
      title="Wait"
      to={resolveStepUrl(step.uuid)}
      type={step.type}
      className="items-center justify-center gap-2"
      active={step.uuid === currentStep?.uuid}
      depth={depth}
    >
      <div className="flex-1 border-b border-gray-400" />
      <span className="flex items-center gap-1 py-2">
        <Icon
          icon={
            step.state === State.Finished
              ? "heroicons/outline/chevron-down"
              : "heroicons/solid/pause"
          }
          className="h-3 w-3"
        />
      </span>
      <div className="flex-1 border-b border-gray-400" />
    </StepLink>
  );
}
